export default "__VITE_ASSET__DaZDRrL6__"